var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 201,
    viewBox: "0 0 240 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1370_20015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2409 125.135C59.2409 125.135 78.4757 166.075 54.3694 170.595C30.2632 175.115 24.1061 147.985 24.1061 147.985L15.3877 153.61C15.3877 153.61 24.9096 184.928 51.4365 184.898C77.9634 184.868 95.9125 176.21 95.4002 147.985C94.888 119.761 59.2409 125.135 59.2409 125.135Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M59.2409 125.135C59.2409 125.135 78.4757 166.075 54.3694 170.595C30.2632 175.115 24.1061 147.985 24.1061 147.985L15.3877 153.61C15.3877 153.61 24.9096 184.928 51.4365 184.898C77.9634 184.868 95.9125 176.21 95.4002 147.985C94.888 119.761 59.2409 125.135 59.2409 125.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7363 65.5122L80.0926 67.9128L68.6321 72.6838C68.6321 72.6838 44.6163 93.3147 53.3447 115.241C62.0732 137.168 101.427 157.718 101.427 157.718L116.995 137.449L87.7363 65.5122Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 0H87.3672V200.925H240V0Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M164.555 136.174C188.481 136.174 207.876 127.899 207.876 117.692C207.876 107.485 188.481 99.2109 164.555 99.2109C140.63 99.2109 121.234 107.485 121.234 117.692C121.234 127.899 140.63 136.174 164.555 136.174Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.951 30.6585C110.002 30.6585 112.475 28.1852 112.475 25.1342C112.475 22.0832 110.002 19.6099 106.951 19.6099C103.9 19.6099 101.427 22.0832 101.427 25.1342C101.427 28.1852 103.9 30.6585 106.951 30.6585Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.53 30.6585C125.581 30.6585 128.055 28.1852 128.055 25.1342C128.055 22.0832 125.581 19.6099 122.53 19.6099C119.479 19.6099 117.006 22.0832 117.006 25.1342C117.006 28.1852 119.479 30.6585 122.53 30.6585Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.435 30.6585C140.486 30.6585 142.96 28.1852 142.96 25.1342C142.96 22.0832 140.486 19.6099 137.435 19.6099C134.384 19.6099 131.911 22.0832 131.911 25.1342C131.911 28.1852 134.384 30.6585 137.435 30.6585Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.928 156.423H128.687C125.287 156.423 122.53 159.179 122.53 162.58V167.421C122.53 170.822 125.287 173.578 128.687 173.578H180.928C184.328 173.578 187.085 170.822 187.085 167.421V162.58C187.085 159.179 184.328 156.423 180.928 156.423Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05 179.836C201.244 179.836 207.886 173.194 207.886 165.001C207.886 156.808 201.244 150.166 193.05 150.166C184.857 150.166 178.215 156.808 178.215 165.001C178.215 173.194 184.857 179.836 193.05 179.836Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.667 165.241L191.845 170.786L198.595 160.129",
    stroke: "white",
    strokeWidth: 3.045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2118 48.5269C57.2118 48.5269 58.7185 55.2164 61.2295 59.1939C61.4693 59.5795 61.7831 59.9138 62.1529 60.1774C62.5226 60.441 62.941 60.6286 63.3837 60.7295C63.8264 60.8304 64.2848 60.8425 64.7322 60.7651C65.1797 60.6877 65.6073 60.5224 65.9905 60.2787C67.9993 59.0131 70.2894 56.7129 69.9178 53.0267L70.0484 46.6988C69.9436 45.4285 69.4465 44.2222 68.6259 43.2469C67.8053 42.2716 66.7018 41.5754 65.4682 41.2548C60.9583 39.7884 56.0869 44.4991 57.2118 48.5269Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.988 47.8438L80.0925 67.9122L68.632 72.6832L65.8799 56.1704L69.988 47.8438Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.95 48.2863C60.9915 47.7245 62.9602 46.9256 64.8159 45.9058C64.5045 46.9866 64.5195 48.1353 64.8591 49.2076C65.1986 50.2799 65.8475 51.2278 66.7243 51.9324C67.5501 52.6275 68.5921 53.0136 69.6715 53.0246C70.7509 53.0356 71.8005 52.6708 72.6403 51.9927L69.8279 43.6258C69.4721 42.4181 68.7957 41.3294 67.8708 40.4752C66.9459 39.621 65.8069 39.0333 64.5748 38.7744C63.5055 38.5407 62.4216 38.3797 61.3305 38.2923C58.6085 38.0914 55.5852 40.8335 52.9034 39.8994C52.6331 39.8046 52.3427 39.7819 52.061 39.8336C51.7792 39.8853 51.5158 40.0095 51.2968 40.1941C51.0777 40.3787 50.9106 40.6172 50.8119 40.8861C50.7131 41.155 50.6862 41.445 50.7338 41.7274C51.1657 44.3992 52.9034 48.2662 56.7604 48.5575C57.5005 48.5965 58.2417 48.5047 58.95 48.2863Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9811 51.9122C65.9811 51.9122 65.2278 49.381 67.1764 48.9692C69.125 48.5574 70.2399 52.2135 67.779 53.3686L65.9811 51.9122Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3774 52.6655L57.373 55.7592C57.3136 55.9349 57.2999 56.1229 57.3331 56.3054C57.3664 56.488 57.4454 56.6591 57.5629 56.8027C57.6804 56.9462 57.8324 57.0576 58.0048 57.1263C58.1771 57.1951 58.3641 57.2189 58.5481 57.1955L61.1898 56.864L58.3774 52.6655Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M66.332 59.8069C67.6837 58.9703 68.7595 57.7548 69.4256 56.3115C69.4256 56.3115 70.5104 60.3292 67.4168 65.5121L66.332 59.8069Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8904 148.769C22.8904 148.769 20.1684 138.875 15.3874 137.72C10.6063 136.565 17.0246 152.596 17.0246 152.596L22.8904 148.769Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1115 125.875L13.6104 128.79L18.359 145.901L28.8602 142.987L24.1115 125.875Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2324 76.6108V104.303H22.8076L19.4854 112.188L16.3447 104.303H0V76.6108H39.2324Z",
    fill: "#00AB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7402 88.9051L18.7322 95.9461L26.2654 84.9678",
    stroke: "white",
    strokeWidth: 3.045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1370_20015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.645 59.772H151.355C140.113 59.772 131 68.8851 131 80.1266V107.417C131 118.659 140.113 127.772 151.355 127.772H178.645C189.887 127.772 199 118.659 199 107.417V80.1266C199 68.8851 189.887 59.772 178.645 59.772Z",
    fill: "#004E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.242 73.3628H154.836C161.672 73.3628 167.275 78.9569 167.275 85.8023V95.286H154.682C147.845 95.286 142.242 89.6919 142.242 82.8465V73.3628Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.93 101.424H183.07C181.32 101.424 179.879 99.9917 179.879 98.2327V91.7773H187.93V91.6957C187.93 87.3074 184.34 83.7261 179.96 83.7261H173.505V101.343H144.637V109.394H147.828C147.828 112.023 149.977 114.181 152.615 114.181C155.254 114.181 157.403 112.032 157.403 109.394H158.998C158.998 112.023 161.147 114.181 163.786 114.181C166.424 114.181 168.573 112.032 168.573 109.394H174.947C174.947 112.023 177.095 114.181 179.734 114.181C182.372 114.181 184.521 112.032 184.521 109.394H187.712V101.424H187.948H187.93Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1370_20015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 200.925,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1370_20015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(131 59.772)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e6f1086674dec4dcf1763083f7b58161.svg";
export { ForwardRef as ReactComponent };